export default (distance: number): string => {
  const km = distance / 1000
  return (Math.round(km * 10) / 10).toLocaleString()
}
